import GenericCheckbox from '../GenericCheckbox/GenericCheckbox'
import { useCallback } from 'react'

interface CheckboxBooleanAttributesProps<T> {
  label: string
  property: 'isGondola' | 'isFresh' | 'allowHighStorage' | 'fractioningTag'
  items: T[];
  updateSelectedItems: (selectedItems: T[]) => void
}

const CheckboxBooleanAttributes: React.FC<CheckboxBooleanAttributesProps<any>> = ({
  label,
  property,
  items,
  updateSelectedItems,
}) => {
  let isChecked = false
  let isIndeterminate = false

  if (items.length > 0) {
    isChecked = items.every((item) => item[property])
    isIndeterminate = !isChecked && items.some((item) => item[property])
  }

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const propertyToChange = event.target.name
    const updatedSelectedItems = items.map((item) => ({
      ...item,
      [propertyToChange]: event.target.checked,
    }))
    updateSelectedItems(updatedSelectedItems)
  }, [items, updateSelectedItems])

  return (
    <GenericCheckbox
      name={property}
      label={label}
      isChecked={isChecked}
      isIndeterminate={isIndeterminate}
      onChange={handleChange}
      disabled={items.length < 1}
    />
  )
}

export default CheckboxBooleanAttributes
